import React from "react";
import EventShowcase from "../../containers/EventShowcase/EventShowcase";
import { incubation_menu,event_gallery_content } from "../../constants/incubation";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { FaComputer } from "react-icons/fa6";
import { RadialMenu, Listformat, Table, Heroimagecarousal } from "../../components";
import { focus_sectors, focus_sector_mentors, incubation_img_corousal } from '../../constants/incubation'

function EventGallery() {
  const img1 =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/MAIN_BUILDING_WEBSITE.webp";
  const img2 =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/MAIN_BUILDING_WEBSITE.webpx";
  const images = [img1, img2];

  return (
    <>
      <div className="incubationdept">
        <Heroimagecarousal
          key={incubation_img_corousal.id}
          title={incubation_img_corousal.title}
          img_list={incubation_img_corousal.img_list}
        />
        {/* <div className="incubationbg">
                <div className="incubationheading">
                    Alagappa Incubation Forum
                </div>
            </div> */}
        <section className="incubationdark">
          <div className="dept_float_menu">
            <Floatinmenu
              logo={FaComputer}
              head="Menu"
              links={incubation_menu}
            />
          </div>
          <RadialMenu menu_links={incubation_menu} />
          <div>
            {/* <EventShowcase
              heading="Glimpse of the First Event by AIF"
              // date="17.07.2025"
              // organizer="Alagappa Incubation Forum, ACGCET"
              content={`A Knowledge Sharing Session on “Innovation and Startup Ecosystem” was organized by the Alagappa Incubation Forum, ACGCET, on 17.07.2025. The session, led by Mr. K. Sakthivel, Project Lead, StartupTN (Madurai Hub), inspired students and faculty to embrace entrepreneurship and innovation, fostering a strong startup mindset across the campus.`}
              images={images}
            /> */}
            {event_gallery_content.map((evt, i) => {
              const { id, heading, date, organizer, content, images } = evt;
              return (
                <EventShowcase
                  key={id ?? i}
                  heading={heading}
                  date={date}
                  organizer={organizer}
                  content={content}
                  images={images}
                />
              );
            })}
          </div>
        </section>

        <Backtotop />
      </div>
    </>
  );
}

export default EventGallery;
